<template>
  <div v-if="goalUserForm">
    <el-dialog :visible.sync="goalUserFormVisible" width="75%">
      <el-tabs type="card">

        <!-- =============================================================== -->
        <el-tab-pane label="Goal Settings">

          <!-- TODO: Button to disable entirely -->
          <el-form label-width="160px" label-position="left" @submit.native.prevent>
            <el-form-item label="Show Image?">
              <el-checkbox size="small" v-model="goalUserForm.showImage">Visible</el-checkbox>
            </el-form-item>

            <el-form-item label="Shadow Blur">
              <el-input-number size="small" v-model="goalUserForm.shadowBlur" controls-position="right" :min="0" :max="30"></el-input-number>
            </el-form-item>

            <el-form-item label="Shadow Color">
              <el-color-picker v-model="goalUserForm.shadowColor"></el-color-picker>
            </el-form-item>

            <el-form-item label="Shadow Offset (X)">
              <el-input-number size="small" v-model="goalUserForm.shadowOffset.x" controls-position="right" :min="-20" :max="20"></el-input-number>
            </el-form-item>

            <el-form-item label="Shadow Offset (Y)">
              <el-input-number size="small" v-model="goalUserForm.shadowOffset.y" controls-position="right" :min="-20" :max="20"></el-input-number>
            </el-form-item>

            <el-form-item label="Shadow Opacity">
              <el-input-number size="small" v-model="goalUserForm.shadowOpacity" controls-position="right" :min="0" :max="1" :precision="2" :step="0.1"></el-input-number>
            </el-form-item>
          </el-form>

          <!--
          <CollapseGroup title="Info" :initCollapse="true">
            Nothing to see
          </CollapseGroup>
          -->

        </el-tab-pane>

        <!-- =============================================================== -->
        <el-tab-pane label="Headline Settings">

          <el-form label-width="160px" label-position="left" @submit.native.prevent>
            <el-form-item label="Show Headline?">
              <el-checkbox v-model="goalUserForm.showHeadline">Visible</el-checkbox>
            </el-form-item>

            <el-form-item label="Font Size">
              <el-select v-model="headlineUserForm.fontSize" placeholder="Select font size">
                <el-option v-for="size in fontSizes"
                  :key="size.value"
                  :label="size.label"
                  :value="size.value" />
              </el-select>
            </el-form-item>

            <el-form-item label="Font Family">
              <el-select v-model="headlineUserForm.fontFamily" placeholder="Select font face">
                <el-option v-for="font in fontFaces"
                  :key="font.value"
                  :label="font.label"
                  :value="font.value"
                  :style="{ fontFamily: font.value }"/>
              </el-select>
            </el-form-item>
          </el-form>

        </el-tab-pane>

        <!-- =============================================================== -->
        <el-tab-pane label="Commitment Settings">
          <el-form label-width="160px" label-position="left" @submit.native.prevent>
            <el-form-item label="Show Commitments?">
              <el-checkbox v-model="goalUserForm.showCommitments">Visible</el-checkbox>
            </el-form-item>
          </el-form>
        </el-tab-pane>

      </el-tabs>

      <el-row style="margin-top: 1em">
        <el-button type="primary" @click="updateUserGoalWithFormData">Update</el-button>
      </el-row>

    </el-dialog>
  </div>
</template>

<script>
// import CollapseGroup from '@/components/DevPlanner/CollapseGroup';
import { fontSizes, fontFaces } from './availableSettings';

export default {
  data: () => ({
    goalId: null,
    goalUserForm : null,
    headlineUserForm: null,
    goalUserFormVisible: false,
    // TODO: be able to remove fontSize / inherit
    // TODO: be able to remove fontFaces / inherit
    fontSizes: fontSizes,
    fontFaces: fontFaces
  }),
  computed: {
    // ...mapGetters("goal", [
    //   "goal_list_state",
    // ]),
  },
  methods: {
    // -------------------------------------------------------------------------

    showUpdateModal({ goalId }) {
      console.log("showGoalUpdateForm", goalId );
      // let userGoal = this.goal_list_state[ goalId ].meta;
      let userGoal = this.$models.goalMeta.getNode( goalId )
      console.log("userGoal", userGoal);

      this.goalId = goalId;
      this.goalUserForm = {
        shadowBlur: userGoal.graphicalRepresentation.shadowBlur,
        shadowColor: userGoal.graphicalRepresentation.shadowColor,
        shadowOffset: Object.assign({}, userGoal.graphicalRepresentation.shadowOffset),
        shadowOpacity: userGoal.graphicalRepresentation.shadowOpacity,
        showCommitments: userGoal.graphicalRepresentation.showCommitments,
        showHeadline: userGoal.graphicalRepresentation.showHeadline,
        showImage: userGoal.graphicalRepresentation.showImage,
      };
      this.headlineUserForm = {
        fontFamily: userGoal.graphicalRepresentation.headline.fontFamily,
        fontSize: userGoal.graphicalRepresentation.headline.fontSize,
      };
      this.goalUserFormVisible = true;
    },

    updateUserGoalWithFormData() {

      console.log("saving", this.goalUserForm);

      let userGoal = this.goal_list_state[ this.goalId ].meta;
      let headlineUserFormLocal = Object.assign({},
          userGoal.graphicalRepresentation.headline,
          this.headlineUserForm);
      let userGoalLocal = Object.assign({},
          userGoal.graphicalRepresentation,
          this.goalUserForm,
          { headline: headlineUserFormLocal });

      console.log("date:", { graphicalRepresentation: userGoalLocal });

      this.$api.update_user_goal({
        goal_id: this.goalId,
        data: { graphicalRepresentation: userGoalLocal }
      });

      this.goalUserFormVisible = false;
    },
  },
  components: {
    // CollapseGroup
  }
}
</script>
